import { MeasurementUnit, phase, Unit } from "../models/units.models";

export const INTENSITY_UNITS = 'A';
export const VOLTAGE_UNITS = 'V';
export const TEMPERATURE_UNITS = 'ºC';
export const FREQUENCY_UNITS = 'Hz';
export const FLICKER_UNITS = 'Pst';
export const POWER_UNITS = 'W';
export const PERCENTAGE_UNITS = '%';
export const KWH_UNITS = 'kWh';

export const UNITS: Record<Unit, MeasurementUnit> = {
  degrees: TEMPERATURE_UNITS,
  amperes: INTENSITY_UNITS,
  volts: VOLTAGE_UNITS,
  hertz: FREQUENCY_UNITS,
  watts: POWER_UNITS,
  pst: FLICKER_UNITS,
  a: INTENSITY_UNITS,
  v: VOLTAGE_UNITS,
  C: TEMPERATURE_UNITS,
  hz: FREQUENCY_UNITS,
  '%': PERCENTAGE_UNITS,
  kWh: KWH_UNITS,
};

export const PHASE: Record<NonNullable<phase>, string> = {
  s: 'S',
  r: 'R',
  t: 'T',
}
